require('./umDragAndDropDomManager');
require('./dragAndDrop.less');
require('./dragAndDrop.tpl.html');
require('./dragAndDropController');

const DragAndDropComponent = {
    templateUrl: '/formViewer/debug/dragAndDrop/dragAndDrop.tpl.html',
    controller: 'dragAndDropDebuggerController',
    bindings: {}
};

angular.module('umFormViewer')
    .component('umDragAndDropDebugger', DragAndDropComponent);
